import React from 'react';
import { AppProviders } from './providers/AppProviders';
import { AppRouter } from './router/AppRouter';

export default function Root() {
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
}
